function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 132 132"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M66.557 33.02A42.498 42.498 0 0097.48 63.944c1.361.34 1.361 2.274 0 2.614A42.498 42.498 0 0066.557 97.48c-.34 1.361-2.274 1.361-2.614 0A42.498 42.498 0 0033.02 66.557c-1.361-.34-1.361-2.274 0-2.614A42.498 42.498 0 0063.943 33.02c.34-1.361 2.274-1.361 2.614 0z"
}));